import { useConfig } from "@jti/app-context/useConfig";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useAuthHrefResolver } from "@jti/ui/providers/AuthRoutingProvider";
import { useTranslations } from "@jti/ui/providers/useTranslations";

export const TradeInSignInBanner = () => {
  const { __ } = useTranslations();
  const { HOME_PAGE_URL, exploreProductsUrlForTradeInAvailableWithoutLogin } = useConfig();
  const resolveAuthHref = useAuthHrefResolver();

  const signInButtonText = __("productdetails.tradein.sign_in.btn");
  const exploreButtonText = __("productdetails.tradein.sign_in.explore");

  const onSignInClick = async () => {
    await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: signInButtonText,
      cta_location: "trade-in_alert_banner",
    });

    window.location.href = resolveAuthHref({
      route: AUTH_ROUTE_PATHS.login,
      search: { returnUrl: window.location.pathname },
    });
  };

  const onExploreClick = async () => {
    await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: exploreButtonText,
      cta_location: "trade-in_alert_banner",
    });

    window.location.href = exploreProductsUrlForTradeInAvailableWithoutLogin || HOME_PAGE_URL;
  };

  return (
    <AlertBanner
      tone="warning"
      title={__("productdetails.tradein.sign_in.title")}
      description={__("productdetails.tradein.sign_in.description")}
      actions={[
        {
          label: signInButtonText,
          onClick: onSignInClick,
        },
        {
          label: exploreButtonText,
          onClick: onExploreClick,
        },
      ]}
    />
  );
};
